import type { Subscription } from "@/shared/types"

export const useSubscriptionStore = () => {
  const activeSubscription = useState<Subscription | null>("activeSubscription")
  const activeSubscriptionPendingRequestCount = useState<number>(
    "activeSubscriptionPendingRequestCount",
    () => 0,
  )
  const activeSubscriptionPending = computed(
    () => activeSubscriptionPendingRequestCount.value > 0,
  )

  const fetchActiveSubscription = async () => {
    activeSubscriptionPendingRequestCount.value += 1
    try {
      const { data } = await useAPI<Subscription>("/subscriptions/active")
      activeSubscription.value = data.value ?? null
      return activeSubscription.value
    } finally {
      activeSubscriptionPendingRequestCount.value = Math.max(
        0,
        activeSubscriptionPendingRequestCount.value - 1,
      )
    }
  }

  return {
    activeSubscription,
    activeSubscriptionPending,
    fetchActiveSubscription,
  }
}
